import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectSpread2.js";
import r from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/objectDestructuringEmpty.js";
import i from "../../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/extends.js";
import "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import * as s from "@radix-ui/react-tooltip";
//#region src/components/primitives/tooltip.tsx
var c = ["delayDuration"], l = [
	"className",
	"sideOffset",
	"children"
];
function u(e) {
	let { delayDuration: r = 0 } = e, i = t(e, c);
	return /* @__PURE__ */ a(s.Provider, n({
		"data-slot": "tooltip-provider",
		delayDuration: r
	}, i));
}
function d(e) {
	let t = i({}, (r(e), e));
	return /* @__PURE__ */ a(u, { children: /* @__PURE__ */ a(s.Root, n({ "data-slot": "tooltip" }, t)) });
}
function f(e) {
	let t = i({}, (r(e), e));
	return /* @__PURE__ */ a(s.Trigger, n({ "data-slot": "tooltip-trigger" }, t));
}
function p(r) {
	let { className: i, sideOffset: c = 8, children: u } = r, d = t(r, l);
	return /* @__PURE__ */ a(s.Portal, { children: /* @__PURE__ */ o(s.Content, n(n({
		"data-slot": "tooltip-content",
		sideOffset: c,
		className: e("z-50 rounded-lg bg-[#1a1a1a] px-3 py-2 text-xs font-semibold leading-4 text-white text-center", "animate-in fade-in-0 zoom-in-95", "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", i)
	}, d), {}, { children: [u, /* @__PURE__ */ a(s.Arrow, { className: "fill-[#1a1a1a]" })] })) });
}
//#endregion
export { d as Tooltip, p as TooltipContent, u as TooltipProvider, f as TooltipTrigger };

//# sourceMappingURL=tooltip.js.map